var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "rail-bet-row" }, [
    _c(
      "div",
      { staticClass: "rail-bet-row__head" },
      [
        _c("span", { staticClass: "rail-bet-row__table" }, [
          _vm._v(_vm._s(_vm.row.table) + " #" + _vm._s(_vm.row.round)),
        ]),
        _vm.row.betsCount
          ? _c(
              "button",
              {
                staticClass: "rail-bet-row__bets",
                class: { open: _vm.expanded },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.expanded = !_vm.expanded
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.row.betsCount) +
                    " " +
                    _vm._s(_vm.$t("Bets")) +
                    " "
                ),
                _c("span", { staticClass: "rail-bet-row__bets-chevron" }, [
                  _vm._v("▾"),
                ]),
              ]
            )
          : _vm.row.market
          ? _c("TxMarketBadge", {
              staticClass: "rail-bet-row__market",
              attrs: { market: _vm.row.market },
            })
          : _c(
              "span",
              {
                class: [
                  "rail-bet-row__side",
                  `rail-bet-row__side--${_vm.row.sideKey}`,
                ],
              },
              [_vm._v(_vm._s(_vm.row.side))]
            ),
        _c("span", { staticClass: "rail-bet-row__stake" }, [
          _vm._v(_vm._s(_vm.row.stake)),
        ]),
      ],
      1
    ),
    _vm.row.selections && _vm.expanded
      ? _c(
          "ul",
          { staticClass: "rail-bet-row__selections" },
          _vm._l(_vm.row.selections, function (selection) {
            return _c(
              "li",
              { key: selection.id, staticClass: "rail-bet-row__selection" },
              [
                selection.market
                  ? _c("TxMarketBadge", { attrs: { market: selection.market } })
                  : _c(
                      "span",
                      {
                        class: [
                          "rail-bet-row__side",
                          `rail-bet-row__side--${selection.sideKey}`,
                        ],
                      },
                      [_vm._v(" " + _vm._s(selection.side) + " ")]
                    ),
                _c("span", { staticClass: "rail-bet-row__selection-stake" }, [
                  _vm._v(_vm._s(selection.stake)),
                ]),
                _c(
                  "span",
                  {
                    class: [
                      "rail-bet-row__payout",
                      `rail-bet-row__payout--${selection.payoutKind || "odds"}`,
                    ],
                  },
                  [_vm._v(" " + _vm._s(selection.payout) + " ")]
                ),
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
    _c("div", { staticClass: "rail-bet-row__foot" }, [
      _vm.row.result
        ? _c(
            "span",
            { staticClass: "rail-bet-row__result" },
            [
              _vm._l(_vm.row.result.dice, function (die, index) {
                return _c("img", {
                  key: index,
                  attrs: {
                    src: _vm.diceImage(die),
                    alt: `Die ${index + 1}: ${die}`,
                  },
                })
              }),
              _c("em", { staticClass: "rail-bet-row__total" }, [
                _vm._v("= " + _vm._s(_vm.row.result.total)),
              ]),
              _c("em", { staticClass: "rail-bet-row__outcome" }, [
                _vm._v(_vm._s(_vm.row.result.label)),
              ]),
            ],
            2
          )
        : _c(
            "span",
            {
              class: [
                "rail-bet-row__status",
                `rail-bet-row__status--${_vm.row.statusKey}`,
              ],
            },
            [_vm._v(" " + _vm._s(_vm.$t(_vm.row.status)) + " ")]
          ),
      _c("span", { class: ["rail-bet-row__payout", _vm.payoutClass] }, [
        _vm._v(_vm._s(_vm.row.payout)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }